interface ReadOnlyFieldProps {
  label: string;
  value?: string | number | null;
  mono?: boolean;
}

/** Label-over-value pair used throughout the read-only details cards. */
const ReadOnlyField = ({ label, value, mono }: ReadOnlyFieldProps) => (
  <div className="tw-flex tw-flex-col tw-gap-0.5">
    <p className="tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">
      {label}
    </p>
    <p className={`tw-text-sm tw-font-medium tw-text-foreground ${mono ? "tw-font-mono" : ""}`}>
      {value === undefined || value === null || value === "" ? "-" : value}
    </p>
  </div>
);

export default ReadOnlyField;
